export default class Tabs {
  constructor({tabs, content} = {}) {
    this.tabs = document.querySelectorAll(tabs);
    this.content = document.querySelectorAll(content);

    this.switch = this.switch.bind(this);

    this.init();
  }

  init() {
    if (!this.tabs || !this.content) return;
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach(tab => tab.addEventListener('click', this.switch));
  }

  switch(e) {
    e.preventDefault();
    let currentIndex = [...this.tabs].indexOf(e.currentTarget);
    let currentTab = e.currentTarget.parentNode;
    let currentContent = this.content[currentIndex];

    this.tabs.forEach(tab => tab.parentNode.classList.remove('is-active'));
    this.content.forEach(c => c.classList.remove('is-active'));

    currentTab.classList.add('is-active');
    currentContent.classList.add('is-active');
  }
};